/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const table = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 6v11.5h16V6H4zm1.5 1.5h6V11h-6V7.5zm0 8.5v-3.5h6V16h-6zm13 0H13v-3.5h5.5V16zM13 11V7.5h5.5V11H13z" />
	</SVG>
);

export default table;
